// TextInput.tsx

import React, { ChangeEvent } from 'react'
import './TextInput.scss'
import { BlurEvent, FieldError } from 'common.types'
import { FieldErrorList } from 'components/FieldErrorList/FieldErrorList'
import { RequiredBar } from 'components/RequiredBar/RequiredBar'
import { getInputClasses } from 'utilities/utilities'
import { FaRegCheckCircle } from 'react-icons/fa'
import { InputStatusIcon } from 'components'

interface TextInputProps {
  label: string
  value: string
  required?: boolean
  onChange: (value: string) => void
  onBlur: (e: BlurEvent) => void
  placeholder?: string
  name: string
  errorList?: FieldError[]
  postalCode?: boolean
  postalCodeInternational?: boolean
  maxLength?: number
}

export const TextInput: React.FC<TextInputProps> = ({
  label,
  value,
  onChange,
  required = false,
  placeholder,
  name,
  errorList,
  postalCode,
  postalCodeInternational,
  maxLength,
  onBlur,
}) => {
  const errorsExist = errorList && errorList.length > 0
  const inputEntered = value?.length > 0
  return (
    <div
      className={`input-wrapper text-input${
        errorsExist ? ' input-wrapper--error' : ''
      }`}
    >
      <label htmlFor={name} className="text-input__label">
        {required && (
          <span className="text-input__label__required-asterisk">*</span>
        )}
        {label}
      </label>
      <div
        className={`text-input__input ${getInputClasses(
          errorsExist,
          inputEntered,
        )}`}
      >
        <RequiredBar
          isRequired={required}
          errorsExist={errorsExist}
          inputEntered={inputEntered}
        />
        <input
          type="text"
          onBlur={onBlur}
          name={name}
          required={required}
          className="text-input__input__input"
          value={value}
          onChange={(e) => {
            let value = ''
            if (postalCode) {
              value = e.target.value.replace(/-/g, '')
              if (!postalCodeInternational) {
                value = value.replace(/\D/g, '')
              }
              const maxZipValue = maxLength
                ? maxLength
                : postalCodeInternational
                ? 10
                : 9
              if (value.length > maxZipValue) {
                value = value.slice(0, maxZipValue)
              }
              if (!postalCodeInternational && value.length > 5) {
                value = value.slice(0, 5) + '-' + value.slice(5)
              }
            } else if (maxLength !== undefined) {
              value = e.target.value.slice(0, maxLength)
            } else {
              value = e.target.value
            }

            onChange(value)
          }}
          placeholder={placeholder}
        />
        <InputStatusIcon
          errorsExist={errorsExist ? true : false}
          inputEntered={inputEntered}
        />
      </div>
      <FieldErrorList errorListForField={errorList} />
    </div>
  )
}
